export function FlagTricolorBar({ className = '' }: { className?: string }) {
  return (
    <div
      className={`h-[3px] w-full rounded-full ${className}`}
      style={{
        background: 'linear-gradient(to right, #009739, #FCD116, #CE1126)',
      }}
      role="img"
      aria-label="Grenada flag colours"
    />
  );
}
